import {connect} from 'react-redux'
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/Button';


const AmazonShowpingLink = (props) =>{
  if(props){
    if(!props.canShowAmazonLinks){
      return (
        <span className="amazon-link">
            {(props.size === "sm" && props.data) &&
            <Button variant="contained"   target="_blank" color="primary"  href={props.data.amazon_url}>
               <i style={{color:"gold"}} class="fab fa-amazon"></i>
            </Button>
            }
            {(props.size === "md" && props.data.amazon_url) &&
            (
              <Button variant="contained"   target="_blank" color="primary"  href={props.data.amazon_url} style={{color:"white"}}>
                {"See On Amazon "} <i style={{paddingLeft:"10px", color:"gold"}} class="fab fa-amazon"></i>
              </Button>
            )
            }
            {(props.size === "lg" && props.data.amazon_url) &&
            (<a className="" target="_blank" href={props.data.amazon_url}>
              <h1 className={"amazon-icon"}> <i class="fab fa-amazon"></i></h1>
              <h5 className={"amazon-text"}> {props.data.title}</h5>
            </a>)
            }
        </span>
      )
    }
    return (<span className={"amazon_showping_link"}>
          {props.size === "sm" && props.data &&
            <Button variant="contained"   target="_blank" color="primary"  href={props.data.amazon_url}>
               <i style={{color:"gold"}} class="fab fa-amazon"></i>
            </Button>
          }
          {props.size === "md" && props.data && props.data.amazon_i_frame &&
            <Button variant="contained"   target="_blank" color="primary"  href={props.data.amazon_url} style={{color:"white"}}>
              {"See On Amazon "} <i style={{paddingLeft:"10px", color:"gold"}} class="fab fa-amazon"></i>
            </Button>
          }
          {(props.size === "md" && !props.data.amazon_i_frame) &&
              <a className="showping-link-md" target="_blank" href={props.url}>
                <img class="optionImage mr-3" src={props.data.img_url} alt="phone image">
                </img>
              </a>
          }
          {props.size === "lg" && props.data && props.data.amazon_i_frame &&
              <div dangerouslySetInnerHTML={{ __html: props.data.amazon_i_frame}} onLoad={()=>console.log("i was loaded!")}/>
          }
          {props.size === "lg" && !props.data.amazon_i_frame &&
              <a className="showping-link-lg" target="_blank" href={props.url}>
                <img class="optionImage mr-3" src={props.data.img_url} alt="phone image">
                </img>
              </a>
          }
          </span>)
  } else {
    return <span></span>;
  }
}


const mapStateToProps = (state) => ({
  canShowAmazonLinks: state.canShowAmazonLinks,
})

const actionsCreators = {
}
export default connect(mapStateToProps, actionsCreators)(AmazonShowpingLink)
